export const EMPLOYEE_RANGES = [
	{ id: "1-10", title: "1-10" },
	{ id: "11-50", title: "11-50" },
	{ id: "51-200", title: "51-200" },
	{ id: "201-500", title: "201-500" },
	{ id: "501-1K", title: "501-1K" },
	{ id: "1K-5K", title: "1K-5K" },
	{ id: "5K-10K", title: "5K-10K" },
	{ id: "over-10K", title: "Over 10K" },
];
